// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fuse-widget {
  display: block;
  position: relative;
  perspective: 3000px;
  padding: 12px;
}
fuse-widget > div {
  position: relative;
  transform-style: preserve-3d;
  transition: transform 1s;
}
fuse-widget > .fuse-widget-front {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  position: relative;
  overflow: hidden;
  visibility: visible;
  width: 100%;
  opacity: 1;
  z-index: 10;
  border-radius: 2px;
  transition: transform 0.5s ease-out 0s, visibility 0s ease-in 0.2s, opacity 0s ease-in 0.2s;
  transform: rotateY(0deg);
  backface-visibility: hidden;
}
fuse-widget > .fuse-widget-back {
  display: block;
  position: absolute;
  top: 12px;
  right: 12px;
  bottom: 12px;
  left: 12px;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  z-index: 10;
  transition: transform 0.5s ease-out 0s, visibility 0s ease-in 0.2s, opacity 0s ease-in 0.2s;
  transform: rotateY(180deg);
  backface-visibility: hidden;
}
fuse-widget > .fuse-widget-back [fuseWidgetToggle] {
  position: absolute;
  top: 0;
  right: 0;
}
fuse-widget.flipped > .fuse-widget-front {
  visibility: hidden;
  opacity: 0;
  transform: rotateY(180deg);
}
fuse-widget.flipped > .fuse-widget-back {
  display: block;
  visibility: visible;
  opacity: 1;
  transform: rotateY(360deg);
}
fuse-widget .mat-form-field.mat-form-field-type-mat-select .mat-form-field-wrapper {
  padding: 16px 0;
}
fuse-widget .mat-form-field.mat-form-field-type-mat-select .mat-form-field-wrapper .mat-form-field-infix {
  border: none;
  padding: 0;
}
fuse-widget .mat-form-field.mat-form-field-type-mat-select .mat-form-field-underline {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/@fuse/components/widget/widget.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AACJ;AACI;EACI,kBAAA;EACA,4BAAA;EACA,wBAAA;AACR;AAEI;EACI,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,2FAAA;EACA,wBAAA;EACA,2BAAA;AAAR;AAEI;EACI,cAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,2FAAA;EACA,0BAAA;EACA,2BAAA;AAAR;AAEQ;EACI,kBAAA;EACA,MAAA;EACA,QAAA;AAAZ;AAMQ;EACI,kBAAA;EACA,UAAA;EACA,0BAAA;AAJZ;AAOQ;EACI,cAAA;EACA,mBAAA;EACA,UAAA;EACA,0BAAA;AALZ;AAaY;EACI,eAAA;AAXhB;AAagB;EACI,YAAA;EACA,UAAA;AAXpB;AAeY;EACI,aAAA;AAbhB","sourcesContent":["fuse-widget {\n    display: block;\n    position: relative;\n    perspective: 3000px;\n    padding: 12px;\n\n    > div {\n        position: relative;\n        transform-style: preserve-3d;\n        transition: transform 1s;\n    }\n\n    > .fuse-widget-front {\n        display: flex;\n        flex-direction: column;\n        flex: 1 1 auto;\n        position: relative;\n        overflow: hidden;\n        visibility: visible;\n        width: 100%;\n        opacity: 1;\n        z-index: 10;\n        border-radius: 2px;\n        transition: transform 0.5s ease-out 0s, visibility 0s ease-in 0.2s, opacity 0s ease-in 0.2s;\n        transform: rotateY(0deg);\n        backface-visibility: hidden;\n    }\n    > .fuse-widget-back {\n        display: block;\n        position: absolute;\n        top: 12px;\n        right: 12px;\n        bottom: 12px;\n        left: 12px;\n        overflow: hidden;\n        visibility: hidden;\n        opacity: 0;\n        z-index: 10;\n        transition: transform 0.5s ease-out 0s, visibility 0s ease-in 0.2s, opacity 0s ease-in 0.2s;\n        transform: rotateY(180deg);\n        backface-visibility: hidden;\n\n        [fuseWidgetToggle] {\n            position: absolute;\n            top: 0;\n            right: 0;\n        }\n    }\n\n    &.flipped {\n\n        > .fuse-widget-front {\n            visibility: hidden;\n            opacity: 0;\n            transform: rotateY(180deg);\n        }\n\n        > .fuse-widget-back {\n            display: block;\n            visibility: visible;\n            opacity: 1;\n            transform: rotateY(360deg);\n        }\n    }\n\n    .mat-form-field {\n\n        &.mat-form-field-type-mat-select {\n\n            .mat-form-field-wrapper {\n                padding: 16px 0;\n\n                .mat-form-field-infix {\n                    border: none;\n                    padding: 0;\n                }\n            }\n\n            .mat-form-field-underline {\n                display: none;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
